import React, {useMemo} from 'react';
import {Title} from '@app/titles/models/title';
import {getTitleLink} from '@app/titles/title-link';
import {localizedSegment} from '@app/i18n/localize-link';
import {Trans} from '@ui/i18n/trans';
import {BaseMediaLink, BaseMediaLinkProps} from '@app/base-media-link';

export interface SeasonLinkProps extends Omit<BaseMediaLinkProps, 'link'> {
  title: Title;
  seasonNumber: number;
}
export function SeasonLink({
  title,
  seasonNumber,
  children,
  color = 'inherit',
  ...linkProps
}: SeasonLinkProps) {
  const link = useMemo(() => {
    return getSeasonLink(title, seasonNumber);
  }, [title, seasonNumber]);

  return (
    <BaseMediaLink {...linkProps} link={link}>
      {children ?? (
        <Trans message="Season :number" values={{number: seasonNumber}} />
      )}
    </BaseMediaLink>
  );
}

export function getSeasonLink(
  title: Title,
  seasonNumber: number | string,
  {absolute}: {absolute?: boolean} = {},
): string {
  // BLOK 3d: başlık öneki zaten localize (getTitleLink); sezon segment'ini de
  // aktif locale'e çevir (tr→sezon, es→temporada, en→season …) → non-TR 404 fix.
  const titleLink = getTitleLink(title, {absolute});
  return `${titleLink}/${localizedSegment('sezon')}/${seasonNumber}`;
}
